import React, { Component } from 'react';
import { Alert as AlertNative } from 'react-native';
import { View, Text, isWeb, Link } from 'core';
import { style, theme } from 'constants';
import { lang } from 'lang';

let Alert;
const styles = style({
  holder: {
    backgroundColor: theme.gray_color_alpha(0.4),
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    //justifyContent:'center',
    position: 'absolute',
    flex: 1
  },
  content: {
    backgroundColor: 'white',
    minWidth: 700,
    minHeight: 170,
    marginTop: 300,
    padding: 40
  },
  title: {
    fontSize: 20,
    marginVertical: 10
  },
  message: {
    color: theme.gray_color_lighten(0.6)
  }
});
export class AlertProvider extends Component {
  state = { show: false, title: '', message: '', buttons: [] };
  componentDidMount() {
    Alert = this;
  }
  alert = (title, message, buttons = [{ text: lang.OK }], options, type) => {
    this.setState({ show: true, title, message, buttons });
  };
  render() {
    const { show, title, message, buttons } = this.state;
    const box = (
      <View style={styles.holder}>
        <View style={styles.content}>
          <View style={{ flex: 1 }}>
            {title ? <Text style={styles.title}>{title}</Text> : null}
            {message ? <Text style={styles.message}>{message}</Text> : null}
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
            {buttons.map(b => (
              <Link
                style={{ paddingHorizontal: 15 }}
                selected
                key={b.text}
                title={b.text}
                onPress={(...ar) => {
                  b.onPress && b.onPress(...ar);
                  this.setState({ show: false });
                }}
              />
            ))}
          </View>
        </View>
      </View>
    );
    return show ? box : null;
  }
}

Alert = isWeb?Alert:AlertNative
export {Alert}



// WEBPACK FOOTER //
// ./src/components/core/alert.js